declare const __APP_VERSION__: string;

/**
 * The version this bundle was built from, in the MAJOR.MINOR(.PATCH) shape the app displays.
 *
 * Substituted at build time from the root `VERSION` file (`vite.config.ts`) — NOT a
 * hand-maintained constant, and deliberately so. Several places name the version and
 * `e2e/14-about.spec.ts` fails the build when they disagree; adding another that a person has
 * to remember would be adding a way to be wrong.
 *
 * NO STRIPPING HAPPENS HERE (V0.37.1): `VERSION` is already in exactly the display shape,
 * unlike `client/package.json`'s real semver, which pads a two-segment version with a build
 * number that used to need trimming — and which a genuine three-segment version ("0.37.1")
 * cannot be distinguished from by string shape alone. Reading `VERSION` directly sidesteps
 * that ambiguity instead of guessing at it.
 *
 * It is only ever the STARTING value. `/api/version` is what the app shows once it answers,
 * because a cached page can be older than the server it is talking to, and the number people
 * quote in a support request has to be the running one.
 */
export const BUILD_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '';
